import styled from 'styled-components'

import { Image as ImageBase } from '@application/Interfaces/Atoms/Image'
import { Button as ButtonBase } from '@icontainers/design-system/dist/molecules/Button'

export const Wrapper = styled.div`
    background-color: ${(props) => props.theme.color.white};
    ${(props) => props.theme.boxShadow.level2};
`
export const Image = styled(ImageBase)`
    margin-bottom: 10px;
    max-width: 125px;
`

export const Header = styled.div`
    padding: 20px;
    border-bottom: 1px solid ${(props) => props.theme.color.p500};
    text-align: center;
`

export const Title = styled.h3`
    ${(props) => props.theme.typo.bodyL};
    ${(props) => props.theme.fontWeight.medium};
    color: ${(props) => props.theme.color.black};
`

export const Body = styled.div`
    padding: 10px 20px;
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.regular};
`

export const Label = styled.div``

export const Value = styled.span`
    ${(props) => props.theme.fontWeight.medium};
    text-align: right;
`

export const ItemContainer = styled.div`
    ${Label} {
        margin-bottom: 15px;

        &:last-of-type {
            margin-bottom: 0;
        }
    }
`

export const Footer = styled.div`
    padding: 10px 20px;
    background-color: ${(props) => props.theme.color.g100};
`

export const Button = styled(ButtonBase)`
    width: 100%;

    button {
        width: 100%;
    }
`
